/* Binom v2 LP Pixel. The tracker returns JavaScript containing tokens.bcid.
 * Visits use key + lp_type=pixel; offer clicks use lp=1 + the SAME bcid.
 * No conversion pixel is fired on a visit or an offer click.
 */
(function () {
  'use strict';
  if (window.OdorCrushTracking) return;
  var configNode = document.getElementById('odor-crush-binom-config');
  if (!configNode) return;
  var config, endpoint;
  try {
    config = JSON.parse(configNode.textContent);
    endpoint = new URL(config.endpoint);
    if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password) return;
    endpoint.search = '';
    endpoint.hash = '';
  } catch (error) { return; }

  var query = new URLSearchParams(window.location.search);
  var clickId = null;
  var waiting = [];
  var pendingNavigation = false;
  var pixelTimer;
  var state = window.OdorCrushTracking = {
    status: 'idle',
    getClickId: function () { return clickId; },
    getOfferUrl: offerUrl
  };

  function validId(value) {
    return typeof value === 'string' && /^[A-Za-z0-9_-]{1,200}$/.test(value) ? value : null;
  }
  function setStatus(status) {
    state.status = status;
    document.documentElement.setAttribute('data-binom-status', status);
  }
  function offerUrl(link) {
    var url = new URL(endpoint.href);
    // Preserve optional offer selection parameters on individual links.
    if (link) {
      try {
        new URL(link.href).searchParams.forEach(function (value, key) {
          if (key !== 'bcid') url.searchParams.set(key, value);
        });
      } catch (error) { /* Use the configured click URL. */ }
    }
    ['key', 'lp_type', 'cnv_id', 'upd_clickid', 'upd_key'].forEach(function (key) {
      url.searchParams.delete(key);
    });
    url.searchParams.set('lp', '1');
    url.searchParams.delete('bcid');
    if (clickId) url.searchParams.set('bcid', clickId);
    return url.href;
  }
  function refreshLink(link) { link.href = offerUrl(link); }
  function refreshLinks() {
    document.querySelectorAll('a[data-binom-offer]').forEach(refreshLink);
  }
  function settle(status) {
    clearTimeout(pixelTimer);
    setStatus(status);
    refreshLinks();
    var callbacks = waiting.splice(0);
    callbacks.forEach(function (callback) { callback(); });
  }
  function findOffer(event) {
    return event.target && event.target.closest ? event.target.closest('a[data-binom-offer]') : null;
  }
  function refreshOnIntent(event) {
    var link = findOffer(event);
    if (link) refreshLink(link);
  }
  ['pointerdown', 'focusin', 'contextmenu'].forEach(function (name) {
    document.addEventListener(name, refreshOnIntent, true);
  });

  function handleOfferClick(event) {
    var link = findOffer(event);
    if (!link || event.defaultPrevented || event.button > 1) return;
    refreshLink(link);
    // Once ready (or failed), use a normal link: keyboard, modifier keys,
    // popup policy and browser context menus keep their native behavior.
    if (state.status !== 'loading') return;
    event.preventDefault();
    if (pendingNavigation) return;
    pendingNavigation = true;
    link.setAttribute('aria-busy', 'true');
    var newTab = link.target === '_blank' || event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1;
    var tab = null;
    if (newTab) {
      // Open INSIDE the user gesture, before any asynchronous wait.
      // Set opener to null before navigating away from our blank document.
      try {
        tab = window.open('about:blank', '_blank');
        if (tab) tab.opener = null;
      } catch (error) { tab = null; }
    }
    var navigated = false;
    var timer;
    function navigate() {
      if (navigated) return;
      navigated = true;
      clearTimeout(timer);
      var index = waiting.indexOf(navigate);
      if (index !== -1) waiting.splice(index, 1);
      link.removeAttribute('aria-busy');
      pendingNavigation = false;
      var url = offerUrl(link);
      refreshLink(link);
      if (tab) {
        // If the visitor closed the waiting tab, respect that action.
        if (!tab.closed) tab.location.replace(url);
      } else {
        window.location.assign(url);
      }
    }
    waiting.push(navigate);
    // A blocked/slow tracker must not trap the visitor on the landing page.
    // Without a returned ID, fallback routing depends on Binom's cookies.
    timer = setTimeout(navigate, 4000);
  }
  document.addEventListener('click', handleOfferClick);
  document.addEventListener('auxclick', handleOfferClick);
  window.addEventListener('pageshow', refreshLinks);

  var preview = config.designMode || (window.Shopify && window.Shopify.designMode) || query.has('preview_theme_id');
  if (!config.enabled || preview || (!config.landing && !config.trackInfoPages)) {
    settle('disabled');
    return;
  }
  // A tracker redirect can supply an existing click. Do not count it twice.
  // Never reuse a stale cookie from a previous direct landing visit.
  clickId = validId(query.get('bcid'));
  if (clickId) {
    settle('ready');
    return;
  }
  if (!config.campaignKey) { settle('error'); return; }
  var pixelUrl = new URL(endpoint.href);
  // Retain traffic-source tokens; remove tracker commands from an incoming URL.
  var reserved = /^(key|lp|lp_type|bcid|uclick|cnv_id|upd_clickid|upd_key|to_offer|to_lander|event\d*|add_event\d*|event_\d+|binom_.*|preview_.*)$/;
  query.forEach(function (value, key) {
    if (!reserved.test(key)) pixelUrl.searchParams.set(key, value);
  });
  ['lp', 'bcid', 'cnv_id', 'upd_clickid', 'upd_key', 'to_offer', 'to_lander'].forEach(function (key) {
    pixelUrl.searchParams.delete(key);
  });
  pixelUrl.searchParams.set('key', config.campaignKey);
  pixelUrl.searchParams.set('lp_type', 'pixel');
  setStatus('loading');
  refreshLinks();
  var script = document.createElement('script');
  var previousTokens = window.tokens;
  script.id = 'odor-crush-binom-pixel';
  script.async = true;
  script.src = pixelUrl.href;
  script.onload = function () {
    clickId = window.tokens !== previousTokens ? validId(window.tokens && window.tokens.bcid) : null;
    settle(clickId ? 'ready' : 'error');
  };
  script.onerror = function () { settle('error'); };
  pixelTimer = setTimeout(function () { settle('timeout'); }, 10000);
  document.head.appendChild(script);
})();
